import React, { PureComponent } from "react";
import { Mutation, Query } from "react-apollo";
import NotificationsRecipientField from "components/NotificationsRecipientField";
import styles from "./styles.css";
import { updateDirtyStateMutation } from "mutations/updateDirtyStateMutation";
import gql from "graphql-tag";

const dirtyStateQuery = gql`
  query {
    dirtyState @client {
      notificationRecipient
    }
  }
`;

class NotificationStep extends PureComponent {
  render() {
    return (
      <Mutation mutation={updateDirtyStateMutation}>
        {mutate => (
          <Query query={dirtyStateQuery}>
            {({ data: { dirtyState } }) => (
              <div className={styles.notificationsContainer}>
                <NotificationsRecipientField
                  value={dirtyState.notificationRecipient}
                  onChange={notificationRecipient =>
                    mutate({
                      variables: { data: { notificationRecipient } },
                    })
                  }
                />
              </div>
            )}
          </Query>
        )}
      </Mutation>
    );
  }
}
export default NotificationStep;



// WEBPACK FOOTER //
// ./src/components/NotificationStep/index.js